import type { ConnectedAccount } from "@seamapi/http"
import { useQuery } from "@tanstack/react-query"
import { useSeamHttpClient } from "./use-seam-client"
import { default_refetch_interval_ms } from "api-hooks/default-refetch-interval"

interface UseConnectedAccountsOptions {
  should_poll?: boolean
  search?: string
}

export const useConnectedAccounts = (
  workspace_id = "",
  options?: UseConnectedAccountsOptions
) => {
  const seam = useSeamHttpClient(workspace_id)
  const search = options?.search?.trim()

  return useQuery({
    queryKey: ["connected_accounts", workspace_id, search],
    queryFn: async () =>
      await seam.connectedAccounts.list(search ? { search } : undefined),
    enabled: Boolean(seam) && Boolean(workspace_id),
    refetchInterval: options?.should_poll
      ? default_refetch_interval_ms
      : undefined,
  })
}
